import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
// import rnDevice from 'rhino/src/components/device/device.module';
// import rnSession from 'rhino/src/components/session/session.module';
// import rnHttp from 'rhino/src/core/http/http.module';
// import rnPreferences from 'rhino/src/components/preferences/preferences.module';
import * as acceptAccount from './accept-account.controller';
import gzEula from 'gazelle/src/components/user/eula/eula.module';
import gzHpId from 'gazelle/src/components/hpid/hpid.module';

// import this modules components

import './accept-account.scss';

// define the module in one place and export the module name
export default angular.module('register.components.acceptaccount', [
  gzEula,
  uiRouter,
  ngMaterial,
  angularTranslate,
  gzHpId,
  'rhino.components.locale',
  'rhino.components.invitation',
  'rhino.components.session',
  'rhino.components.preferences',
  'rhino.components.locale',
  'rhino.core',
  'angulartics'
])
  .controller(acceptAccount.name, acceptAccount.default)
  .name;



// WEBPACK FOOTER //
// ./components/accept/account/accept-account.module.js